import React, { useState, useEffect } from "react";
import { Camera, Mail, MapPin, Phone, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  const locations = [
    {
      title: "Dev Bhoomi Group Companies",
      address: ["8 mile stone, Behdala", "Una, Himachal Pradesh", "174306"],
    },
    {
      title: "Dev Bhoomi TMT",
      address: ["8 mile stone, Behdala", "Una, Himachal Pradesh", "174306"],
    },
    {
      title: "Dev Bhoomi TMT Sales Pvt. Ltd.",
      address: [
        "Ground Floor, NH 21,",
        "Opposite Reliance Petrol Pump,",
        "Gutkar, Himachal Pradesh",
        "175021",
      ],
    },
    {
      title: "Dev Bhoomi Motors Pvt. Ltd.",
      address: [
        "Ground Floor, NH 21,",
        "Opposite Reliance Petrol Pump,",
        "Gutkar, Himachal Pradesh",
        "175021",
      ],
    },
    {
      title: "Dev Bhoomi Cars Pvt. Ltd.",
      address: [
        "Plot No 104,",
        "Industrial Area,",
        "Shoghi, Himachal Pradesh",
        "171001",
      ],
    },
    {
      title: "Dev Bhoomi Wheels LLP",
      address: [],
    },
    {
      title: "Dev Bhoomi Gulmohar Grand Pvt. Ltd.",
      address: [
        "The Gulmohar Grand Hotel",
        "8 mile stone, Behdala",
        "Una, Himachal Pradesh",
        "174306",
      ],
    },
    {
      title: "Dev Bhoomi Electric Car Pvt. Ltd.",
      address: [
        "Dev Bhoomi Group Companies",
        "8 mile stone, Behdala",
        "Una, Himachal Pradesh",
        "174306",
      ],
    },
    {
      title: "Dev Bhoomi Craftsman Pvt. Ltd.",
      address: [
        "Head Office",
        "Dev Bhoomi Group Companies",
        "8 mile stone, Behdala",
        "Una, Himachal Pradesh",
        "174306",
      ],
    },
  ];

  // Group locations into 3 columns for display
  const groupedLocations = [
    locations.slice(0, 3),
    locations.slice(3, 6),
    locations.slice(6),
  ];

  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Radial gradient background */}
      <div className="absolute inset-0 bg-radial-gradient from-amber-900/10 via-transparent to-transparent"></div>

      {/* Abstract shapes */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-amber-500 blur-3xl"></div>
        <div className="absolute top-3/4 right-1/4 w-64 h-64 rounded-full bg-yellow-500 blur-3xl"></div>
        <div className="absolute bottom-1/4 left-3/4 w-64 h-64 rounded-full bg-amber-500 blur-3xl"></div>
      </div>

      {/* Subtle grid pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      {/* Main content */}
      <div className="relative pt-24 pb-12 z-10 bg-gray-900">
        <div className="container mx-auto px-4">
          {/* Upper Section */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 pb-12">
            {/* Company Info */}
            <div data-aos="fade-right">
              <div className="flex items-center mb-6">
                <div className="mr-4 p-1 rounded-lg shadow-lg">
                  <img
                    src="https://ik.imagekit.io/zfayt6inj/lofgodb.jpg?updatedAt=1748852043440"
                    alt="Dev Bhoomi Group Companies Logo"
                    className="h-16 w-16 object-contain"
                  />
                </div>
                <div>
                  <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-amber-400 to-yellow-500">
                    Dev Bhoomi Group Companies
                  </h2>
                  <p className="text-gray-400 text-sm">Excellence since 2005</p>
                </div>
              </div>

              <p className="text-gray-300 mb-6 leading-relaxed">
                Dev Bhoomi Group Companies is a diversified conglomerate with business
                interests spanning automotive, hospitality, manufacturing, and
                real estate sectors across Himachal Pradesh and beyond.
              </p>

              <div className="space-y-6 text-sm text-gray-300">
                {/* Address */}
                <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
                  <div className="bg-amber-900/30 p-2 rounded-md flex items-center justify-center w-fit sm:mt-1">
                    <MapPin size={20} className="text-amber-400" />
                  </div>
                  <div className="mt-2 sm:mt-0">
                    <p className="font-medium">Dev Bhoomi Group Companies</p>
                    <p>Admin Block at The Gulmohar Grand,</p>
                    <p>8 mile stone, Una Chandigarh</p>
                    <p>Highway Behdala, Una,</p>
                    <p>Himachal Pradesh, 174306</p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
                  <div className="bg-amber-900/30 p-2 rounded-md flex items-center justify-center w-fit sm:mt-1">
                    <Phone size={20} className="text-amber-400" />
                  </div>
                  <div className="mt-2 pt-2 sm:mt-0">
                    <a href="tel:+916230562314" className="hover:text-amber-400 transition-colors">
                      +91 6230562314
                    </a>
                  </div>

                </div>

                {/* Email */}
                <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
                  <div className="bg-amber-900/30 p-2 rounded-md flex items-center justify-center w-fit sm:mt-1">
                    <Mail size={20} className="text-amber-400" />
                  </div>
                  <div className="mt-2 pt-2 sm:mt-0 hover:text-amber-400">
                    <Link to={"mailto:info@devbhoomigroup.in"}> info@devbhoomigroup.in</Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div
              className="md:col-span-1 md:px-20"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h3 className="text-lg font-bold text-white mb-6 flex items-center">
                <span className="h-5 w-1 bg-amber-500 rounded-full mr-2"></span>
                Quick Links
              </h3>
              <ul className="space-y-3">
                {[
                  { name: "About", to: "/about" },
                  { name: "Business", to: "/business" },
                  { name: "Dev Bhoomi Team", to: "/team" },
                  { name: "Careers", to: "/careers" },
                  { name: "Blogs", to: "/blogs" },
                  { name: "Contact", to: "/contact" },
                ].map((item, idx) => (
                  <li key={idx}>
                    <Link
                      to={item.to}
                      className="text-gray-300 hover:text-white transition flex items-center group"
                      aria-label={item.name}
                    >
                      <ChevronRight
                        size={16}
                        className="mr-2 text-amber-500 transform group-hover:translate-x-1 transition-transform"
                      />
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Google Map */}
            <div data-aos="fade-left">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center">
                <span className="h-5 w-1 bg-amber-500 rounded-full mr-2"></span>
                Find Us
              </h3>
              <div className="relative h-64 sm:h-72 md:h-80 rounded-lg overflow-hidden border border-gray-800 shadow-xl group">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-600/20 to-yellow-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none"></div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d32723.697734887915!2d76.32583631041322!3d31.427298223999504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391acf7372e92127%3A0x190e1127f9bcee3!2sDev%20Bhoomi%20Group%20companies!5e0!3m2!1sen!2sin!4v1745478025319!5m2!1sen!2sin"
                  title="Dev Bhoomi Group Companies Location"
                  className="w-full h-full border-0 z-0"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-6 border-t border-gray-700 flex flex-col sm:flex-row items-center justify-between text-sm text-gray-400 space-y-4 sm:space-y-0">
            <div className="text-center sm:text-left">
              © {new Date().getFullYear()}{" "}
              <span className="font-medium text-white">Dev Bhoomi Group Companies</span>.
              All rights reserved.
            </div>
            <div className="flex flex-wrap justify-center gap-4">

            </div>
          </div>
        </div>
      </div>

      {/* Adding CSS for background patterns */}
      <style jsx>{`
        .bg-grid-pattern {
          background-image: linear-gradient(
              rgba(255, 255, 255, 0.05) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(255, 255, 255, 0.05) 1px,
              transparent 1px
            );
          background-size: 20px 20px;
        }

        .bg-radial-gradient {
          background: radial-gradient(
            circle at center,
            var(--tw-gradient-from) 0%,
            var(--tw-gradient-to) 70%
          );
        }

        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }

        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
